module.exports = __webpack_public_path__ + "portal-static/img/live_pop.b907fc9a.png";